import "flowbite"
import componentOptions from "./src/shopify-buy-button-config"

const client = ShopifyBuy.buildClient({
  domain: 'rooks-games-and-more.myshopify.com',
  storefrontAccessToken: '8a840b4f43a5f36d5ccc5bc06bdadbed',
});
window.shopifyUi = ShopifyBuy.UI.init(client);

window.shopifyUi.createComponent('cart', { options: componentOptions() });

import "./controllers"
